<md-dialog>
	<div md-dialog-header>
		<span class="md-text-xl-semibold">Lesson: {{ lessonDate() }}</span>
	</div>

	<div class="lesson-summary-dialog">
		@if ((lesson().grades ?? []).length > 0) {
			<div class="lesson-summary-dialog__section-title">Grades</div>
			<div class="lesson-summary-dialog__grades">
				@for (grade of lesson().grades ?? []; track grade.gradingTemplateCategoryID) {
					<lb-grade-tag [grade]="grade.gradeName" [hexColor]="grade.gradeColor" [categoryName]="grade.categoryName" [compact]="true"></lb-grade-tag>
				}
			</div>
		}

		<div class="lesson-summary-dialog__section-title">Lesson Summary</div>
		<md-content-box>
			@if (lessonSummary()) {
				<lb-rich-text-view class="lesson-summary-dialog__summary" [content]="lessonSummary()" />
			} @else {
				<p class="lesson-summary-dialog__empty">No lesson summary available.</p>
			}
		</md-content-box>
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Close</button>
		<button md-button-brand (click)="viewDetails()">View Details</button>
	</div>
</md-dialog>
